import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProfileSettingsSection } from '../components/profile/ProfileSettingsSection';

const Settings: React.FC = () => {
  const { t } = useTranslation('settings');

  return (
    <div className="flex flex-col md:min-h-[calc(100vh-4rem)] md:px-5 lg:px-32">
      <div className="w-full md:w-2/3 pt-4 md:px-1 md:pr-8 flex flex-col">
        <h1 className="text-[3.375rem] text-secondary font-bold">{t('title')}</h1>
      </div>
      <div className="my-8 md:my-16">
        <ProfileSettingsSection />
      </div>
    </div>
  );
};

export default Settings;
